/**
 * Import required libraries
 */
import React, { useState, useEffect, useMemo } from "react";
import { connect } from "react-redux";
import { iconBase64 } from "Utils";

/**
 * Import required elements
 */
// Material-ui components
import { Avatar as MuiAvatar } from "@material-ui/core";

/**
 * Avatar Component
 */
function Avatar({ pseudo, avatar, iconProps = {} }) {
  //console.log("icons props :", iconProps)
  const [avatarURL, setAvatarURL] = useState("");

  useEffect(() => {
    let mounted = true
    if (avatar) {
      iconBase64(avatar).then(url => {
        if (mounted) setAvatarURL(url)
      }).catch(console.error);
    }
    return () => mounted = false
  }, [avatar])

  let pseudoLetter = useMemo(() => {
    if (pseudo) return pseudo[0].toUpperCase()
    else return ""
  }, [pseudo])

  if (avatar) {
    return <MuiAvatar src={avatarURL} alt="" {...iconProps} />;
  } else return <MuiAvatar {...iconProps}  >{pseudoLetter}</MuiAvatar>;
}

/**
 * Export component
 */
// map redux state to props
export default connect((state, { userUid }) => {
  if (!userUid) userUid = state.user && state.user.userUid;
  if (userUid) {
    let user = state.list.user[userUid];
    if (user) return {
      pseudo: user.pseudo,
      avatar: user.avatar
    };
  } return {};
})(Avatar);
